// Library categories for books.json entries: one primary `category` per title, shown as filter
// chips in this fixed order. Shared by the Books view (app/folders.js) and anything else that
// lists the library, so every place filters the same way. No DOM here.
export const BOOK_CATEGORIES = Object.freeze([
	"Action", "Adventure", "Arcade", "Platformer", "Puzzle", "Racing", "Shooter", "Sports", "Strategy",
	"Idle & Sim", "Music", "Card & Board", "Other",
]);

const KNOWN = new Set(BOOK_CATEGORIES);

// A title's category; a missing or unknown value counts as "Other".
export function bookCategory(b) {
	const c = b && typeof b.category === "string" ? b.category : "";
	return KNOWN.has(c) ? c : "Other";
}

// [[category, count], ...] in the fixed order, leaving out categories with no titles.
export function categoryCounts(items) {
	const n = new Map();
	for (const it of items || []) { const c = bookCategory(it); n.set(c, (n.get(c) || 0) + 1); }
	return BOOK_CATEGORIES.filter((c) => n.get(c)).map((c) => [c, n.get(c)]);
}
